import { Badge as BadgeMantine, BadgeProps } from "@mantine/core";
import { IColor, variantColors } from "../../../utils/selectColors";

interface IProps extends BadgeProps {
  paysucces: boolean;
  border?: boolean;
  value?: string;
}

const TagPay = ({ value, paysucces, border, ...props }: IProps) => {
  const colorSelected: IColor = !!paysucces ? IColor.success : IColor.waiting;
  const selectedVariant = variantColors[colorSelected];

  return (
    <BadgeMantine
      {...props}
      sx={{
        color: selectedVariant.color,
        background: selectedVariant.bg,
        padding: "4px 8px",
        height: "30px",
        fontSize: "14px",
        border: "1px solid",
        borderColor: !!border ? selectedVariant.borderColor : "transparent",
      }}
      radius="sm"
    >
      {!!value ? value : paysucces ? "Pago" : "Pendente"}
    </BadgeMantine>
  );
};

export default TagPay;
